import React from 'react';
import { cellTypes, viewTypes, getCellTypeForRound } from '../enums';
import LeaderboardCellHoleTitle from './leaderboard-cell-hole-title';
import LeaderboardCellPlayerTitle from './leaderboard-cell-player-title';
import LeaderboardCellMoversTitle from './leaderboard-cell-movers-title';
import LeaderboardCellScoresTitle from './leaderboard-cell-scores-title';
import LeaderboardCellTitleBasic from './leaderboard-cell-title-basic';
import LeaderboardCellTitleRound from './leaderboard-cell-title-round';

const LeaderboardRowTitle = (
    {
        view,
        scoringCourseRound,
        toggleRScore,
        sortingHandlerProps,
        processingState,
        currentRound,
    }
) => {
    const renderTitleBasic = (type, sortingHandler) => {
        return (
            <LeaderboardCellTitleBasic
                type={type}
                sortingHandler={sortingHandler}
                processingState={processingState}
            />
        );
    };

    return (
        <div className="leaderboard__title-row">

            {renderTitleBasic(cellTypes.POSITION, sortingHandlerProps, processingState)}

            <LeaderboardCellMoversTitle
                sorted={sortingHandlerProps}
                processingState={processingState}
            />

            <LeaderboardCellPlayerTitle
                toggleRScore={toggleRScore}
                view={view}
                sortingHandlerProps={sortingHandlerProps}
                processingState={processingState}
            />

            {renderTitleBasic(cellTypes.PAR, sortingHandlerProps, processingState)}

            {view === viewTypes.R_SCORE && renderTitleBasic(cellTypes.R1, sortingHandlerProps, processingState)}
            {view === viewTypes.R_SCORE && renderTitleBasic(cellTypes.R2, sortingHandlerProps, processingState)}
            {view === viewTypes.R_SCORE && renderTitleBasic(cellTypes.R3, sortingHandlerProps, processingState)}
            {view === viewTypes.R_SCORE && renderTitleBasic(cellTypes.R4, sortingHandlerProps, processingState)}

            {view === viewTypes.HOLE_BY_HOLE && <LeaderboardCellScoresTitle scoringCourseRound={scoringCourseRound} />}

            {
                view !== viewTypes.R_SCORE &&
                view !== viewTypes.HOLE_BY_HOLE &&
                <LeaderboardCellHoleTitle
                    sortingHandlerProps={sortingHandlerProps}
                    processingState={processingState} />
            }

            {view === viewTypes.R_SCORE && renderTitleBasic(cellTypes.TOTAL, sortingHandlerProps, processingState)}
            {view !== viewTypes.R_SCORE && view !== viewTypes.HOLE_BY_HOLE && renderTitleBasic(cellTypes.TODAY, sortingHandlerProps, processingState)}
            {view === viewTypes.HOLE_BY_HOLE &&
            <LeaderboardCellTitleRound
                type={getCellTypeForRound(currentRound)}
                sortingHandler={sortingHandlerProps}
                processingState={processingState}/>
            }
        </div>
    );
};

export default LeaderboardRowTitle;
